<template>
    <!-- お知らせ登録画面 -->
    <v-form ref="p2Form" v-model="p2Form" lazy-validation>
        <v-container>
            <v-row>
                <v-col>
                    <h5 style="font-size: larger">お知らせ一覧</h5>
                </v-col>
            </v-row>
            <v-card class="gridlist" flat>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-form ref="tableForm" v-model="tableForm" lazy-validation v-if="tableRefresh">
                                <ryou-table ref="ryouTable" :rowKey="rowKey" :headers="headers"
                                    :queryParams="queryParam" :url="url" :handleEdit="handleEdit"
                                    :uploadFile="uploadFile" :handleDelete="handleDelete" :businessKey="businessKey"
                                    :dummy="false" :needSearch="true" :height="height" @selfDelHandler="selfDelHandler">
                                    <v-row slot="filterContainer">
                                        <v-col cols="4"></v-col>
                                        <v-col cols="4" class="addBtn">
                                            <ryou-blue-btn :label="'新規追加'" :handlerClick="handleAdd"></ryou-blue-btn>
                                        </v-col>
                                    </v-row>
                                </ryou-table>
                            </v-form>
                        </v-col>
                    </v-row>
                    <v-row v-show="false">
                        <NoticeRaedJohoDialog ref="modalForm1" :url="url">
                        </NoticeRaedJohoDialog>
                    </v-row>
                    <v-row v-show="false">
                        <UserSelectDialog ref="modalForm" @ok="modalFormOk" :url="url" @setDataByChild="setDataByChild">
                        </UserSelectDialog>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card-title class="InsertTitle" v-show="showKbn">
                <v-toolbar color="primary" dark>お知らせ設定</v-toolbar>
            </v-card-title>
            <v-card class="grid2" v-show="showKbn">
                <v-row>
                    <v-col cols="1" class="headerTitle">
                        <h5 style="font-size: large; padding-left: 0px">物件グループ</h5>
                    </v-col>
                    <v-col cols="2" class="headerGroup">
                        <ryou-select class="bukens" :items="objectGroupItems" :itemText="'build_group_name'"
                            :itemValue="'build_group_id'" v-model="selectGroup" :value="selectGroup"
                            :disabled="noticeDateUpdateFlg" :rules="selectGroupRules">
                        </ryou-select>
                    </v-col>
                    <v-col class="headerData">
                        <div>
                            {{ this.buildingName }}
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" class="txtInput">
                        <ryou-input v-model="noticeTitle" :value="noticeTitle" :label="'件名'" :rules="noticeTitleRules"
                            :maxlength="30">
                        </ryou-input>
                    </v-col>
                    <v-col cols="1">
                        <v-spacer></v-spacer>
                    </v-col>
                    <v-col cols="2">
                        <ryou-checkbox v-model="checkbox1" :value="checkbox1" :label="'掲示板掲載チェック'"
                            :rules="requiredRules"></ryou-checkbox>
                    </v-col>
                    <v-col cols="2" class="txtInput">
                        <ryou-input v-model="board_publish_time" :value="board_publish_time" :label="'掲示板掲載時間'"
                            :rules="inputRules" :maxlength="3"></ryou-input>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2" class="dateInout">
                        <ryou-date-format v-model="date1" :value="date1" :label="'掲載開始日'" :type="'date'"
                            :format="'$1/$2/$3'" :rules="date1Rules"></ryou-date-format>
                    </v-col>
                    <h2 class="dateInout">{{ this.wavyLineMark }}</h2>
                    <v-col cols="2" class="dateInout">
                        <ryou-date-format v-model="date2" :value="date2" :label="'掲載終了日'" :type="'date'"
                            :format="'$1/$2/$3'" :min="selectMin" :rules="date2Rules"></ryou-date-format>
                    </v-col>
                    <v-col cols="1">
                        <v-spacer></v-spacer>
                    </v-col>
                    <v-col :cols="2">
                        <v-form ref="p3Form" v-model="p3Form" lazy-validation>
                            <v-file-input accept="application/pdf" label="登録ファイル" v-model="chosenFile"
                                :rules="inputRulesFile" truncate-length="30">
                            </v-file-input>
                        </v-form>
                    </v-col>
                    <v-col cols="1">
                        <v-card-actions>
                            <ryou-black-btn :label="'アップロード'" :handlerClick="importFile" :iconCls="'mdi-file-upload'">
                            </ryou-black-btn>
                        </v-card-actions>
                    </v-col>
                    <v-col cols="2" class="dbFileName">
                        <ryou-input v-model="dbFileName" :value="dbFileName" :label="'登録済みファイル'"
                            :disabled="fileNameDis">
                        </ryou-input>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="10">
                        <ryou-textarea v-model="textarea" :value="textarea" :label="'内容'" :rules="textareaRules"
                            :outlined="true" :maxlength="512"></ryou-textarea>
                    </v-col>
                </v-row>
                <v-card class="grid3">
                    <v-row>
                        <v-col cols="8" class="headerGroup">
                            <ryou-select class="bukens" :items="objectUserClassItems" :label="'通知先'"
                                :itemText="'code_text'" :itemValue="'code_value'" v-model="selectUserClass"
                                :value="selectUserClass" :rules="selectUserClassRules">
                            </ryou-select>
                        </v-col>
                        <v-col cols="4">
                            <ryou-checkbox v-model="checkbox2" :value="checkbox2" :label="'メール送信有無'"
                                :rules="requiredRules">
                            </ryou-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col :cols="8">
                            <ryou-textarea v-model="textarea1" :value="textarea1" :label="'ユーザ選択'"
                                :rules="requiredRules" :outlined="true" :rows="8" :clearable ="userCle" :autGrow="userAutGrow" :readolny="userreadonly"></ryou-textarea>
                        </v-col>
                        <v-col cols="4">
                            <ryou-checkbox v-model="checkbox3" :value="checkbox3" :label="'既読管理有無'"
                                :rules="requiredRules">
                            </ryou-checkbox>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'"></ryou-black-btn>
                    <v-spacer></v-spacer>
                    <ryou-black-btn :label="'一時保存'" :handlerClick="handleSaveOk" :disabled="btnCtrlSave">
                    </ryou-black-btn>
                    <v-spacer></v-spacer>
                    <ryou-black-btn :label="'登録'" :handlerClick="handleOk" :disabled="btnCtrlToroku"></ryou-black-btn>
                    <v-spacer></v-spacer>
                    <ryou-black-btn :label="'承認'" :handlerClick="handleApprovalOk" :disabled="btnCtrlApproval">
                    </ryou-black-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-container>
        <ryou-confirm ref="confirm"></ryou-confirm>
    </v-form>
</template>

<script>
    import RyouInput from "@/components/formInput/RyouInput.vue";
    import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
    import RyouCheckbox from "@/components/formInput/RyouCheckbox.vue";
    import RyouSelect from "@/components/formInput/RyouSelect.vue";
    import RyouTextarea from "@/components/formInput/RyouTextarea.vue";
    import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
    import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";

    import RyouTable from "@/components/table/RyouTable.vue";
    import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
    import NoticeRaedJohoDialog from "./modules/NoticeRaedJohoDialog.vue";
    import UserSelectDialog from "./modules/UserSelectDialog.vue";

    import { RyouTableMixins } from "@/mixins/RyouTableMixins";
    import { postUploadRequest } from "@/utils/api";

    export default {
        name: "NoticeInformationRegistration",
        mixins: [RyouTableMixins],
        components: {
            RyouInput,
            RyouDateFormat,
            RyouCheckbox,
            RyouSelect,
            RyouTextarea,
            RyouBlackBtn,
            RyouBlueBtn,
            RyouTable,
            RyouConfirm,
            UserSelectDialog,
            NoticeRaedJohoDialog,
        },
        mounted() {
            this.$refs.ryouTable.$on("doLinkEdit", this.linkEdit);
            this.uploadFileUrl = "/noticeConfirmation/tmpFileDownload";

            this.selectGroupRules.push(this.GlobalRules.required);
            this.noticeTitleRules.push(this.GlobalRules.required);
            this.selectUserClassRules.push(this.GlobalRules.required);
            this.date1Rules.push(this.GlobalRules.required);
            this.date2Rules.push(this.GlobalRules.required);
            this.textareaRules.push(this.GlobalRules.required);
            this.inputRules.push(this.GlobalRules.required);
            this.inputRules.push(this.GlobalRules.currency);
        },
        data() {
            return {
                wavyLineMark: "　～　",
                p2Form: true,
                p3Form: true,
                inputRulesFile: [],
                requiredRules: [],
                inputRules: [],
                selectGroupRules: [],
                noticeTitleRules: [],
                selectUserClassRules: [],
                date1Rules: [],
                date2Rules: [],
                textareaRules: [],
                valid: true,
                showKbn: false,
                search: "",
                rowKey: "rowIndex",
                date1: "",
                date2: "",
                selectMin: "",
                selectGroup: "",
                selectUserClass: "",
                noticeDateUpdateFlg: false,
                fileNameDis: true,
                userDis: true,
                userCle: false,
                userAutGrow: false,
                userreadonly:true,
                btnCtrlApproval: true,
                btnCtrlSave: true,
                btnCtrlToroku: true,
                objectGroupItems: [],
                objectUserClassItems: [],
                businessKey: "info_seq_no",
                buildingName: "",
                tableRefresh: true,
                textarea1: "",
                textarea: "",
                notice_user_id: "",
                tableForm: true,
                idFilterValue: "",
                chosenFile: null,
                dbFileName: "",
                dbImageName: "",
                checkbox1: false,
                checkbox2: false,
                checkbox3: false,
                popFlg: true,
                info_seq_no_hid: "",
                approval_status_hid: "",
                noticeTitle: "",
                board_publish_time: "",
                message: "",
                height: 290,
                headers: [
                    {
                        text: "No",
                        class: "blue lighten-2 title",
                        value: "info_seq_no",
                        align: "left",
                        width: "6%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "件名",
                        class: "blue lighten-2 title",
                        value: "title",
                        width: "17%",
                        sortable: true,
                        groupable: false,
                        filter: this.idFilter,
                    },
                    {
                        text: "掲載期間",
                        class: "blue lighten-2 title",
                        value: "publish_kikan",
                        align: "left",
                        width: "24%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "承認状況",
                        class: "blue lighten-2 title",
                        value: "approval_status_name",
                        width: "15%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "未読/既読",
                        class: "blue lighten-2 title",
                        value: "show_kensu",
                        align: "left",
                        type: "link",
                        width: "12%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "添付ファイル",
                        class: "blue lighten-2 title",
                        value: "tmp_file",
                        type: "file",
                        width: "15%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "操作",
                        class: "blue lighten-2 title",
                        value: "actions",
                        align: "center",
                        sortable: false,
                        groupable: false,
                    },
                    {
                        text: "",
                        value: "publish_start_date",
                        width: "0.1%",
                        type: "hidden",
                        sortable: false,
                        groupable: false,
                    },
                    {
                        text: "",
                        value: "publish_end_date",
                        width: "0.1%",
                        type: "hidden",
                        sortable: false,
                        groupable: false,
                    },
                ],

                types: ["success", "error", "warning", "info", "default"],

                url: {
                    list:
                        "/noticeRegistration/noticeInitGet" +
                        "/" +
                        this.$store.getters.getUserId +
                        "/" +
                        this.$store.getters.getUserClass,
                    delete: "/noticeRegistration/noticeInformationDelete",
                    add: "/noticeRegistration/noticeInformationInsert",
                    update: "/noticeRegistration/noticeInformationUpdate",
                },
            };
        },
        created() {
            this.initData();
        },
        watch: {
            selectGroup(value) {
                if (value != null && value != "") {
                    let params = {
                        build_group_id: value,
                    };
                    this.getRequest("/noticeRegistration/buildingNameGet", params, this.$store.getters.getUserToken).then(
                        (data) => {
                            this.buildingName = data.result;
                        }
                    );
                } else {
                    this.buildingName = "";
                }
            },
            checkbox1(val) {
                var ruleIdx = this.inputRules.indexOf(this.GlobalRules.required);
                if (val) {
                    if (ruleIdx === -1) {
                        var length = this.inputRules.length;
                        this.inputRules.splice(length, 0, this.GlobalRules.required);
                    }
                } else {
                    if (ruleIdx >= 0) {
                        this.inputRules.splice(ruleIdx, 1);
                    }
                }
            },

            date1(value) {
                if (value != null && value != "") {
                    this.selectMin = value;
                } else {
                    this.selectMin = "";
                }
                let inDate = new Date(Date.parse(this.date1.replace(/-/g, "/")));
                let outDate = new Date(Date.parse(this.date2.replace(/-/g, "/")));
                if (inDate.getTime() > outDate.getTime()) {
                    this.date2 = "";
                }
            },

            selectUserClass(value) {
                if (value == "99" && !this.checkbox1 && this.popFlg) {
                    this.$refs.modalForm.selectUsers();
                } else if (value != "99") {
                    this.popFlg = true;
                    this.textarea1 = "";
                    this.notice_user_id = "";
                }
            },
        },
        methods: {
            initData() {
                let params = {
                    userId: this.$store.getters.getUserId,
                    userClass: this.$store.getters.getUserClass,
                };
                this.getRequest("/noticeRegistration/buildGroupGet", params, this.$store.getters.getUserToken).then(
                    (data) => {
                        if (data.success) {
                            this.objectGroupItems = data.result; //物件グループ名
                            //this.objectGroupItems.push(this.selectGroup);
                        }
                    }
                );
                this.getRequest("/noticeRegistration/selectListGet", params, this.$store.getters.getUserToken).then(
                    (data) => {
                        if (data.success) {
                            this.objectUserClassItems = data.result[0].children; //通知先
                            //this.objectUserClassItems.push(this.selectUserClass);
                        }
                    }
                );
            },

            selfDelHandler(item) {
                if (
                    item.publish_start_date.toString().substr(0, 10) <=
                    new Date().toISOString().substr(0, 10) &&
                    item.publish_end_date.toString().substr(0, 10) >=
                    new Date().toISOString().substr(0, 10)
                ) {
                    //var that = this;
                    this.$refs.confirm
                        .open(
                            "削除",
                            "対象のお知らせは現在掲載中です。削除しても宜しいですか？",
                            { color: "blue" }
                        )
                        .then((confirm) => {
                            if (confirm) {
                                this.handleDelete(item);
                            }
                        });
                } else {
                    this.handleDelete(item);
                }
            },

            handleDelete(item) {
                var that = this;
                this.$refs.confirm
                    .open("削除", "削除します。宜しいですか？", { color: "blue" })
                    .then((confirm) => {
                        if (confirm) {
                            let params = {
                                user_id: this.$store.getters.getUserId,
                                info_seq_no: item.info_seq_no,
                            };

                            this.deleteRequest(that.url.delete, params, this.$store.getters.getUserToken).then((res) => {
                                if (res.success) {
                                    that.$refs.ryouTable.loadData();
                                }
                            });
                        }
                    });
            },

            //既読状況Link
            linkEdit(item) {
                this.$refs.modalForm1.edit(item.info_seq_no);
            },

            //編集ボタン
            handleEdit(record) {
                this.noticeDateUpdateFlg = true;
                this.showKbn = true;
                this.clearDate();
                this.noticeInformationGet(record);
            },

            //お知らせ情報取得
            noticeInformationGet(record) {
                var that = this;
                let params = {
                    infoSeqNo: record.info_seq_no,
                };
                this.getRequest("/noticeRegistration/noticeInformationGet", params, this.$store.getters.getUserToken).then(
                    (data) => {
                        // お知らせ情報画面表示
                        if (data.success) {
                            that.info_seq_no_hid = data.result[0].info_seq_no;
                            that.approval_status_hid = data.result[0].approval_status;
                            that.noticeTitle = data.result[0].title;
                            that.selectGroup = data.result[0].build_group_id;
                            that.textarea = data.result[0].message;
                            if (data.result[0].show_class == "1") {
                                that.checkbox1 = true;
                            } else if (data.result[0].show_class == "0") {
                                that.checkbox1 = false;
                            }
                            if (data.result[0].board_publish_time == 0) {
                                that.board_publish_time = "";
                            } else {
                                that.board_publish_time = data.result[0].board_publish_time;
                            }
                            that.date1 = data.result[0].publish_start_date
                                .toString()
                                .substr(0, 10);
                            that.date2 = data.result[0].publish_end_date
                                .toString()
                                .substr(0, 10);
                            that.dbFileName = data.result[0].tmp_file;
                            that.dbImageName = data.result[0].tmp_image;
                            that.selectUserClass = data.result[0].user_class;
                            if (data.result[0].mail_send_flg == "1") {
                                that.checkbox2 = true;
                            } else if (data.result[0].mail_send_flg == "0") {
                                that.checkbox2 = false;
                            }
                            if (data.result[0].read_check_flg == "1") {
                                that.checkbox3 = true;
                            } else if (data.result[0].read_check_flg == "0") {
                                that.checkbox3 = false;
                            }
                            if (data.result[0].user_class == "99") {
                                this.popFlg = false;
                                if (
                                    data.result[0].user_id != null &&
                                    data.result[0].user_id != ""
                                ) {
                                    var userIds = "";
                                    var userNames = "";
                                    data.result.forEach((item) => {
                                        userIds += item.user_id + "/";
                                        userNames += item.user_name + "\r\n";
                                    });
                                    that.notice_user_id = userIds;
                                    that.textarea1 = userNames;
                                }
                            } else {
                                this.popFlg = true;
                            }
                            this.btnCtrl(true, that.approval_status_hid);
                        }
                    }
                );
            },

            //新規追加ボタン
            handleAdd() {
                this.clearDate();
                this.noticeDateUpdateFlg = false;
                this.showKbn = true;
                var that = this;
                that.noticeTitle = "";
                that.selectGroup = "";
                that.info_seq_no_hid = "";
                that.textarea = "";
                that.textarea1 = "";
                that.checkbox1 = false;
                that.board_publish_time = "";
                that.date1 = "";
                that.date2 = "";
                that.chosenFile = null;
                that.dbFileName = "";
                that.dbImageName = "";
                that.selectUserClass = "";
                that.checkbox2 = false;
                that.checkbox3 = false;
                that.approval_status_hid = "";
                that.notice_user_id = "";
                this.btnCtrl(false, that.approval_status_hid);
            },

            // 個別選択一覧
            setDataByChild(arr) {
                this.notice_user_id = arr[0];
                this.textarea1 = arr[1];
            },

            //登録ファイル
            importFile() {
                this.$refs.p2Form.resetValidation();
                this.inputRulesFile.push(this.GlobalRules.required);
                var valid = this.$refs.p3Form.validate();
                if (valid) {
                    var uploadKbn = "";
                    if (this.checkbox1) {
                        uploadKbn = "1";
                    } else {
                        uploadKbn = "0";
                    }
                    var pInfoSeqNo = 0;
                    if (this.info_seq_no_hid != null && this.info_seq_no_hid != "") {
                        pInfoSeqNo = this.info_seq_no_hid;
                    }
                    let formData = new FormData();
                    formData.append("file", this.chosenFile);

                    let url =
                        "/noticeRegistration/fileUpload" + "/" + uploadKbn + "/" + pInfoSeqNo;

                    postUploadRequest(url, formData, this.$store.getters.getUserToken).then((resp) => {
                        if (resp.success) {
                            this.dbFileName = resp.result[0];

                            this.dbImageName = resp.result[1];
                        }
                    });
                }
            },

            // 登録ボタン
            handleOk() {
                this.$refs.p3Form.resetValidation();

                var ruleIdx = this.inputRules.indexOf(this.GlobalRules.required);
                if (this.checkbox1) {
                    if (ruleIdx === -1) {
                        var length = this.inputRules.length;
                        this.inputRules.splice(length, 0, this.GlobalRules.required);
                    }
                } else {
                    if (ruleIdx >= 0) {
                        this.inputRules.splice(ruleIdx, 1);
                    }
                }
                var valid = this.$refs.p2Form.validate();
                if (valid) {
                    if (this.noticeDateUpdateFlg) {
                        this.$refs.confirm
                            .open("更新", "更新します。宜しいですか？", { color: "info" })
                            .then((confirm) => {
                                if (confirm) {
                                    this.approval_status_hid = "1";
                                    this.noticeInformationUpdate();
                                }
                            });
                    } else {
                        this.$refs.confirm
                            .open("登録", "登録します。宜しいですか？", { color: "info" })
                            .then((confirm) => {
                                if (confirm) {
                                    this.approval_status_hid = "1";
                                    this.noticeInformationInsert();
                                }
                            });
                    }
                }
            },

            // 一時保存
            handleSaveOk() {
                this.$refs.p3Form.resetValidation();

                var ruleIdx = this.inputRules.indexOf(this.GlobalRules.required);
                if (this.checkbox1) {
                    if (ruleIdx === -1) {
                        var length = this.inputRules.length;
                        this.inputRules.splice(length, 0, this.GlobalRules.required);
                    }
                } else {
                    if (ruleIdx >= 0) {
                        this.inputRules.splice(ruleIdx, 1);
                    }
                }
                var valid = this.$refs.p2Form.validate();
                if (valid) {
                    if (this.noticeDateUpdateFlg) {
                        this.$refs.confirm
                            .open("一時保存", "更新します。宜しいですか？", { color: "info" })
                            .then((confirm) => {
                                if (confirm) {
                                    this.approval_status_hid = "0";
                                    this.noticeInformationUpdate();
                                }
                            });
                    } else {
                        this.$refs.confirm
                            .open("一時保存", "登録します。宜しいですか？", { color: "info" })
                            .then((confirm) => {
                                if (confirm) {
                                    this.approval_status_hid = "0";
                                    this.noticeInformationInsert();
                                }
                            });
                    }
                }
            },

            // 承認
            handleApprovalOk() {
                this.$refs.p3Form.resetValidation();

                var ruleIdx = this.inputRules.indexOf(this.GlobalRules.required);
                if (this.checkbox1) {
                    if (ruleIdx === -1) {
                        var length = this.inputRules.length;
                        this.inputRules.splice(length, 0, this.GlobalRules.required);
                    }
                } else {
                    if (ruleIdx >= 0) {
                        this.inputRules.splice(ruleIdx, 1);
                    }
                }
                var valid = this.$refs.p2Form.validate();
                if (valid) {
                    if (this.noticeDateUpdateFlg) {
                        this.$refs.confirm
                            .open("承認", "承認します。宜しいですか？", { color: "info" })
                            .then((confirm) => {
                                if (confirm) {
                                    this.approval_status_hid = "2";
                                    this.noticeInformationUpdate();
                                }
                            });
                    }
                }
            },

            // お知らせ情報更新
            noticeInformationUpdate() {
                var that = this;

                if (that.checkbox1) {
                    var show_class = "1";
                } else {
                    show_class = "0";
                }
                if (that.checkbox2) {
                    var mail_send_flg = "1";
                } else {
                    mail_send_flg = "0";
                }
                if (that.checkbox3) {
                    var read_check_flg = "1";
                } else {
                    read_check_flg = "0";
                }
                if (that.textarea1 != null && that.textarea1 != "") {
                    that.notice_user_id = this.notice_user_id;
                } else {
                    that.notice_user_id = "";
                }
                if (that.board_publish_time == null || that.board_publish_time == "") {
                    that.board_publish_time = 0;
                }
                let params = {
                    user_id: this.$store.getters.getUserId,
                    info_seq_no: that.info_seq_no_hid,
                    title: that.noticeTitle,
                    build_group_id: that.selectGroup,
                    message: that.textarea,
                    board_publish_time: that.board_publish_time,
                    publish_start_date: that.date1,
                    publish_end_date: that.date2,
                    show_class: show_class,
                    tmp_file: that.dbFileName,
                    tmp_image: that.dbImageName,
                    user_class: that.selectUserClass,
                    mail_send_flg: mail_send_flg,
                    read_check_flg: read_check_flg,
                    approval_status: that.approval_status_hid,
                    notice_user_id: that.notice_user_id,
                };
                /// お知らせ情報更新
                that
                    .putRequest("/noticeRegistration/noticeInformationUpdate", params, this.$store.getters.getUserToken)
                    .then((resp) => {
                        //画面表示
                        if (resp.success) {
                            that.$refs.ryouTable.loadData();
                            that.btnCtrl(true, that.approval_status_hid);
                        }
                    });
                setTimeout(() => {
                    return;
                }, 100);
                this.$refs.tableForm.resetValidation();
                this.$refs.p2Form.resetValidation();
                this.$refs.p3Form.resetValidation();
            },

            // お知らせ情報登録
            noticeInformationInsert() {
                var that = this;

                if (that.checkbox1) {
                    var show_class = "1";
                } else {
                    show_class = "0";
                }
                if (that.checkbox2) {
                    var mail_send_flg = "1";
                } else {
                    mail_send_flg = "0";
                }
                if (that.checkbox3) {
                    var read_check_flg = "1";
                } else {
                    read_check_flg = "0";
                }
                if (that.textarea1 != null && that.textarea1 != "") {
                    that.notice_user_id = this.notice_user_id;
                } else {
                    that.notice_user_id = "";
                }
                if (that.board_publish_time == null || that.board_publish_time == "") {
                    that.board_publish_time = 0;
                }
                let params = {
                    user_id: this.$store.getters.getUserId,
                    //info_seq_no: that.info_seq_no_hid,
                    build_group_id: that.selectGroup,
                    title: that.noticeTitle,
                    message: that.textarea,
                    board_publish_time: that.board_publish_time,
                    publish_start_date: that.date1,
                    publish_end_date: that.date2,
                    show_class: show_class,
                    tmp_file: that.dbFileName,
                    tmp_image: that.dbImageName,
                    user_class: that.selectUserClass,
                    mail_send_flg: mail_send_flg,
                    read_check_flg: read_check_flg,
                    approval_status: that.approval_status_hid,
                    notice_user_id: that.notice_user_id,
                };

                // お知らせ情報登録
                that
                    .postRequest("/noticeRegistration/noticeInformationInsert", params, this.$store.getters.getUserToken)
                    .then((resp) => {
                        //画面表示
                        if (resp.success) {
                            that.$refs.ryouTable.loadData();
                            that.btnCtrl(true, that.approval_status_hid);
                            that.handleCancel();
                        }
                    });
                setTimeout(() => {
                    return;
                }, 100);
            },
            btnCtrl(flag, status) {
                if (!flag) {
                    this.btnCtrlSave = false;
                    this.btnCtrlToroku = false;
                    this.btnCtrlApproval = true;
                } else if (status == "0") {
                    this.btnCtrlSave = false;
                    this.btnCtrlToroku = false;
                    this.btnCtrlApproval = true;
                } else if (status == "1") {
                    this.btnCtrlSave = true;
                    this.btnCtrlToroku = false;
                    if (this.$store.getters.getUserClass == "1") {
                        this.btnCtrlApproval = false;
                    } else {
                        this.btnCtrlApproval = true;
                    }
                } else if (status == "2") {
                    this.btnCtrlSave = true;
                    this.btnCtrlToroku = true;
                    this.btnCtrlApproval = true;
                }
            },

            handleCancel() {
                this.$refs.p2Form.resetValidation();
                this.$refs.p3Form.resetValidation();
                this.showKbn = false;
            },

            clearDate() {
                this.$refs.p2Form.resetValidation();
                this.$refs.p3Form.resetValidation();
                this.inputRulesFile = [];

                var that = this;
                that.noticeTitle = "";
                that.selectGroup = "";
                that.textarea = "";
                that.textarea1 = "";
                that.checkbox1 = false;
                that.board_publish_time = "";
                that.date1 = "";
                that.date2 = "";
                that.chosenFile = null;
                that.dbFileName = "";
                that.dbImageName = "";
                that.selectUserClass = "";
                that.checkbox2 = false;
                that.checkbox3 = false;
                that.approval_status_hid = "";
                that.notice_user_id = "";
            },
        },
        computed: {},
    };
</script>

<style>
    .gridlist {
        outline: 1px solid rgb(147, 179, 204);
        padding-top: 0px;
        padding-bottom: 0px;
    }

    .InsertTitle {
        padding: 5px 0px 5px !important;
    }

    .grid1 {
        outline: 1px solid rgb(147, 179, 204);
        padding-top: 0px;
        padding-bottom: 0px;
    }

    .grid2 {
        outline: 1px solid rgb(147, 179, 204);
        padding-top: 0px;
        padding-left: 10px;
        padding-bottom: 2px;
    }

    .grid3 {
        outline: 1px solid hsl(300, 2%, 8%);
        padding-top: 0px;
        padding-left: 10px;
        padding-bottom: 2px;
        width: 850px;
    }

    .addBtn {
        padding-top: 30px;
        text-align: right;
    }

    .headerTitle {
        padding-left: 20px;
        padding-bottom: 0px;
        font-size: large;
    }

    .headerGroup {
        padding-right: 0px;
    }

    .dateInout {
        padding-top: 30px;
    }

    .txtInput {
        padding-top: 20px;
    }

    .dbFileName {
        padding-top: 28px;
        padding-left: 20px;
    }

    .headerData {
        padding-left: 30px;
    }
</style>